<script setup>
import { ref } from 'vue'
import { useApi, ApiError } from '@/composables/api'
import { useMessageStack } from '@/stores/messagestack'
import OtpCodeInput from '@/components/OtpCodeInput.vue'

const props = defineProps({
  username: { type: String, required: true },
  password: { type: String, required: true },
  service: { type: String, required: true },
})

const emit = defineEmits(['success', 'close'])

const { push: openModal } = useMessageStack()
const code = ref('')
const loading = ref(false)
const verifyModel = ref(null)

const { refresh: doVerify } = useApi({
  model: verifyModel,
  method: 'POST',
  url: 'login/verify_totp',
})

async function submit() {
  if (code.value.length !== 6 || loading.value) return
  try {
    loading.value = true
    await doVerify({
      data: {
        username: props.username,
        password: props.password,
        service: props.service,
        code: code.value,
      },
    })
    const token = verifyModel.value?.access_token
    if (!token) {
      openModal({ type: 'error', message: 'Не удалось получить токен входа' })
      return
    }
    emit('success', { access_token: token })
  } catch (err) {
    const msg = err instanceof ApiError ? err.message : 'Неверный код'
    openModal({ type: 'error', message: msg })
    code.value = ''
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div class="totp-challenge">
    <p class="text-muted mb-3">Введите 6-значный код из приложения-аутентификатора.</p>
    <form @submit.prevent="submit">
      <div class="mb-3">
        <OtpCodeInput v-model="code" :disabled="loading" @complete="submit" />
      </div>
      <div class="d-flex gap-2 justify-content-end">
        <button type="button" class="btn btn-outline-secondary" :disabled="loading" @click="emit('close')">
          Отмена
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          :disabled="code.length !== 6 || loading"
        >
          {{ loading ? 'Проверка…' : 'Войти' }}
        </button>
      </div>
    </form>
  </div>
</template>
